import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';

import combineStyles from '../../utils/combineStyles';
import RateStyles from './__styles__/Rate.styles';
import TypographyStyles from '../../styles/typography';

import { AppContext } from '../../AppProvider';
import { CURRENCY_SYMBOL } from '../../constants/constants';
import { formatTime } from '../../utils/Shipment';

export class Rate extends Component {
  static propTypes = {
    shipment: PropTypes.object.isRequired
  };

  state = {
    defaultCurrency: ''
  };

  componentDidMount() {
    const { defaultCurrency } = this.context.globalProps.orgInfo.config;
    this.setState({ defaultCurrency });
  }

  _formatDeliveryDate = (rate, stop) => {
    const { t } = this.props;
    if (stop.actualTimeLocal) {
      return `${t('Actual Delivery')}: ${formatTime(stop.actualTimeLocal)}`;
    } else if (stop.projectedToTimeLocal) {
      return `${t('Projected Delivery')}: ${formatTime(
        stop.projectedToTimeLocal
      )}`;
    } else if (stop.plannedToTimeLocal) {
      return `${t('Planned Delivery')}: ${formatTime(stop.plannedToTimeLocal)}`;
    } else {
      return `${t('Planned Delivery')}: --`;
    }
  };

  render() {
    const { classes, shipment, t } = this.props;
    const { defaultCurrency } = this.state;
    const rate = shipment.selectedShipmentRate;

    let deliveryDate = '--';
    if (rate && shipment.stops) {
      deliveryDate = this._formatDeliveryDate(rate, shipment.stops[1]);
    }

    return (
      <div className={classes.root}>
        {rate && (
          <Fragment>
            <div className={classes.deliveryInfo}>
              <p
                className={classnames(
                  classes.organizationName,
                  classes.headline6
                )}
              >
                {rate.carrier ? rate.carrier.name : rate.carrierName}
              </p>
              <p className={classes.body2}>
                {rate.serviceLevelId} ({rate.transitDays} Days)
              </p>
              <p className={classes.body2}>{deliveryDate}</p>
            </div>
            <div className={classes.priceInfo}>
              <p
                className={classnames(
                  classes.headline5,
                  classes.price,
                  classes.captionText
                )}
              >
                {CURRENCY_SYMBOL[defaultCurrency]}
                {rate.carrierGrandTotal}
              </p>

              <p className={classnames(classes.captionText, classes.caption)}>
                Accessorial: {CURRENCY_SYMBOL[defaultCurrency]}
                {rate.carrierAccessorialTotal}
              </p>
              <p className={classnames(classes.captionText, classes.caption)}>
                Transit: {CURRENCY_SYMBOL[defaultCurrency]}
                {rate.carrierLineHaulTotal}
              </p>
              <p className={classnames(classes.captionText, classes.caption)}>
                Fuel: {CURRENCY_SYMBOL[defaultCurrency]}
                {rate.carrierFuelTotal}
              </p>
            </div>
          </Fragment>
        )}
        {!rate && (
          <div className={classnames(classes.headline6, classes.noRate)}>
            {t('NO RATE SELECTED')}
          </div>
        )}
      </div>
    );
  }
}

Rate.contextType = AppContext;
const RateWithTranslation = withNamespaces()(Rate);
export default withStyles(combineStyles(RateStyles, TypographyStyles))(
  RateWithTranslation
);
